import React from 'react';

interface MessageErrorProps {
  message?: string;
}

const MessageError: React.FC<MessageErrorProps> = ({ message }) => {
  if (!message) {
    return null;
  }

  return <span className="text-[#CC0202] text-[12px] font-normal leading-[14px]">{message}</span>;
};

export default MessageError;
